export const PermissionModifier = Object.freeze({
  ALL: 'all',
  VIEW: 'view',
  CREATE: 'create',
  MODIFY: 'modify',
  DELETE: 'delete',
})
